export default {
  'reviewImport.doNotInclude': 'Do not include duplicates',
  'reviewImport.failedRecords': 'Failed Records',
  'reviewImport.fileUploadCancelled': 'File Upload Cancelled',
  'reviewImport.fileUploadSuccessful': 'File Upload Successful',
  'reviewImport.followingRecords':
    'Displaying first 20 upload errors only. The following records will not be included with import.',
  'reviewImport.importInformation': 'Import Information',
  'reviewImport.includeAll': 'Include all duplicates',
  'reviewImport.overviewInformation': 'Overview Information',
  'reviewImport.possibleDuplicates': 'Possible Duplicates',
  'reviewImport.importContainsDuplicates': 'This import contains possible duplicates.',
  'reviewImport.totalRecords': 'Total Records in File',
  'reviewImport.successfulRecords': 'Successful Records',
  'reviewImport.selectDuplicates': 'Select duplicates',
  'reviewImport.ReviewImport': 'Review Import'
};
